import BaseModel from '../BaseModel';
import InterviewLog from './InterviewLog';
import InterviewImage from './InterviewImage';

export default class Interview extends BaseModel {
  static entity = 'interviews';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      candidateId: this.attr(null),
      status: this.string(null).nullable(),
      viewed: this.boolean(null).nullable(),
      viewedAt: this.string(null).nullable(),
      createdAt: this.attr(null).nullable(),
      opened: this.boolean(false),
      openedAt: this.string(null).nullable(),
      ready: this.boolean(false),
      readyAt: this.string(null).nullable(),
      publication: this.attr(null),
      video: this.attr(null),
      timestamps: this.attr(null),
      logs: this.hasMany(InterviewLog, 'interviewId'),
      images: this.hasMany(InterviewImage, 'interviewId'),
      aiRating: this.attr(null),
      aiReview: this.string(null).nullable(),
    };
  }

  static apiConfig = {
    actions: {
      fetchById(id) {
        return this.get(`interviews/${id}`);
      },
      update(id, payload) {
        return this.patch(`interviews/${id}`, payload);
      },
      open(interviewId) {
        return this.post('accounting/open_interview', {
          interviewId,
        }, {
          save: false,
        });
      },
    },
  }
}
